import { DEFENDR_DRAFT_CONTENT, DEFENDR_HANDLE } from "./draft";

export const DEFAULT_EBOOK_FORM_CONFIG = {
  formId: "fb12f8fd-3e9a-f011-b4cc-000d3a5a7d0d",
  downloadUrl:
    "https://cdn.bfldr.com/QL33D4U/at/4b74ph7tk3jxsns6fpprkt6/2025-FOS-EBK-100-1001_Acoustics_EBook_8x5.pdf",
  downloadFileName: "Forte-Acoustics-Ebook.pdf",
  successTitle: "Enjoy your ebook",
  successBody:
    "Acoustic doors are just one part of our collection. Forte Opening Solutions offers a complete portfolio of architectural wood doors for your next commercial project.",
  learnMoreHref:
    "/brand?utm_campaign=commercial_architect_branded_fortebrandawareness_interiordoors_awareness&utm_source=forte&utm_medium=fortethankyoupage&utm_content=ctr_learnmorelink_eBook_en_na",
  confirmationPath: "/acousticsguide-confirmation",
};

export const getEbookFormConfig = (pageHandle?: string, pathname?: string) => {
  if (pageHandle === DEFENDR_HANDLE || pathname?.includes(DEFENDR_HANDLE)) {
    return {
      formId: DEFENDR_DRAFT_CONTENT.ctaForm.formId,
      downloadUrl: DEFENDR_DRAFT_CONTENT.ctaForm.ebookDownloadUrl,
      downloadFileName: DEFENDR_DRAFT_CONTENT.ctaForm.ebookFileName,
      successTitle: DEFENDR_DRAFT_CONTENT.ctaForm.successTitle,
      successBody: DEFENDR_DRAFT_CONTENT.ctaForm.successBody,
      learnMoreHref: "/contact-us",
      confirmationPath: null,
    };
  }

  return DEFAULT_EBOOK_FORM_CONFIG;
};
